import React from 'react'
import { Loader2 } from 'lucide-react'

import { CarCard } from 'src/features/CarCard'
import { AddCard } from 'src/features/AddCard'
import Container from 'src/components/Container'
import AppBreadcrumb from 'src/components/AppBreadcrumb'

import { useMyCars } from 'src/pages/MyCars/useMyCars'

export const MyCars = (): JSX.Element => {
  const { breadcrumbItems, isLoadingGetCars, userCars, gotoAddCar } =
    useMyCars()

  return (
    <Container>
      <AppBreadcrumb items={breadcrumbItems} />
      <div className="mt-5">
        {isLoadingGetCars ? (
          <div className=" w-full flex items-center justify-center">
            <Loader2 className="animate-spin mt-8" size={36} />
          </div>
        ) : userCars.length > 0 ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {userCars
              .sort((a, b) => Number(b.isActive) - Number(a.isActive))
              .map(car => {
                return <CarCard {...car} key={car.id} />
              })}
            <AddCard gotoAddCar={gotoAddCar} />
          </div>
        ) : (
          <AddCard gotoAddCar={gotoAddCar} />
        )}
      </div>
    </Container>
  )
}
